import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowForward } from '@material-ui/icons';
import classnames from 'classnames';
import NextLink from '../NextLink';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 5,
    color: colors.blueChip,
    margin: '0 -12px',
    cursor: 'pointer',
    '&:hover': {
      color: colors.blueChip,
    },
  },
  linkText: {
    textTransform: 'uppercase',
    lineHeight: 1.57,
  },
  arrowIcon: {
    marginLeft: 14,
    fontSize: 18,
    color: colors.blueChip,
    '&:hover': {
      color: colors.blueChip,
    },
  },
}));

const LinkText = styled.span`
  font-size: ${props => {
    switch (props.size) {
      case 'medium':
        return fontSize.medium;
      case 'large':
        return fontSize.large;
      default:
        return fontSize.regularTitle;
    }
  }}px;
  font-weight: ${props => {
    switch (props.weight) {
      case 'bold':
        return 'bold';
      default:
        return 'normal';
    }
  }};
  }
`;

const ViewDetailsLink = ({ linkText, linkProps, size, weight, className, onClick }) => {
  const classes = useStyles();
  return onClick ? (
    <div className={classnames(classes.linkBox, className)} onClick={onClick}>
      <LinkText size={size} weight={weight} className={classes.linkText}>
        {linkText}
      </LinkText>
      <ArrowForward className={classes.arrowIcon} />
    </div>
  ) : (
    <NextLink className={classnames(classes.linkBox, className)} {...linkProps}>
      <LinkText size={size} weight={weight} className={classes.linkText}>
        {linkText}
      </LinkText>
      <ArrowForward className={classes.arrowIcon} />
    </NextLink>
  );
};

ViewDetailsLink.propTypes = {
  linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
  linkText: PropTypes.string,
  size: PropTypes.string,
  weight: PropTypes.string,
  icon: PropTypes.node,
};

export default ViewDetailsLink;
